import { useAppTranslation } from 'app/config/i18Config/hooks';
import { UnitType } from 'entities/Contract';
import { UnitTypeButton } from '../../model/types';

export const unitTypesMap: Record<UnitType, string> = {
  [UnitType.BOX]: 'Boxes',
  [UnitType.OFFICE]: 'Offices',
  [UnitType.INSURANCE]: 'Insurance',
  [UnitType.PARKING_PLACE]: 'Parking Places',
  [UnitType.POSTAL_BOX]: 'Postal Boxes',
  [UnitType.RENTING_STUFF]: 'Renting Stuff',
  [UnitType.DEPOSIT]: 'Deposits',
};

export const useUnitTypesFilters = (): UnitTypeButton[] => {
  const { t } = useAppTranslation('booking');

  const bookingAvailableUnitTypes: Array<UnitType.BOX | UnitType.OFFICE> = [UnitType.BOX, UnitType.OFFICE];

  const unitTypesButtons: UnitTypeButton[] = Object.values(bookingAvailableUnitTypes).map((unitType) => ({
    label: t(unitTypesMap[unitType]),
    value: unitType,
  }));

  return unitTypesButtons;
};
